export class CompanyInfo {
  id: number;
  tickerSymbol: string;
  name: string;
  logoUrl?: string;

  constructor(data: any) {
    this.id = data.id;
    this.tickerSymbol = data.tickerSymbol;
    this.name = data.name;
    this.logoUrl = data.logoUrl;
  }
}
